import InfoTab from "../../info/InfoTab";

export default InfoTab;
